import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getRelatedTours } from '../services/api';
import { useLanguage } from '../contexts/LanguageContext';
import { TourDateBadge } from './TourDateBadge';
import { tourCurrencySymbol } from '@/lib/utils';

export const RelatedTours = ({ slug }) => {
  const { language, t } = useLanguage();
  const [tours, setTours] = useState([]);
  useEffect(() => {
    getRelatedTours(slug, language).then(res => setTours(res.data)).catch(() => setTours([]));
  }, [slug, language]);
  if (tours.length === 0) return null;
  return (
    <section className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20 pb-20" data-testid="related-tours">
      <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-8">{t('tour.related')}</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {tours.map(tour => (
          <Link key={tour.id} to={`/turlar/${tour.slug}`} className="group bg-white rounded-2xl overflow-hidden border border-gray-100 transition-all hover:-translate-y-1 hover:shadow-xl" data-testid={`related-tour-${tour.slug}`}>
            <div className="relative overflow-hidden h-44">
              <img src={tour.image_url} alt={tour.title} loading="lazy" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
              <TourDateBadge tour={tour} />
            </div>
            <div className="p-4">
              <h3 className="font-bold text-gray-900 line-clamp-2 group-hover:text-orange-500 transition-colors">{tour.title}</h3>
              <p className="mt-2 text-orange-500 font-bold font-ui">{tourCurrencySymbol(tour)}{tour.price}<span className="text-xs text-gray-500 font-normal ml-1">{t('tours.per_person')}</span></p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};
